import urlConfig from "../config/urlConfig.js";
import adminApi from "./adminApi.js";
import devApi from "./devApi.js";
import superApi from "./superApi.js";

var authority = urlConfig.authority;
var erp = urlConfig.erp;
var pos = urlConfig.pos;

// 表单提交的api
var formApi = {
  urlList: [
    //添加消息
    // adminApi.homerenovation.addErpMessageSend,
    //  //[盘点报损报溢]—盘点计划新增、修改接口
    //  adminApi.warehouse.addErpInventoryPlanInfo,
    //  //[盘点报损报溢]—报损报溢新增、修改接口
    //  adminApi.warehouse.addErpOverflowLossInfo,
  ]
};
export default formApi;



// WEBPACK FOOTER //
// ./src/api/formApi.js